import {
  Box,
  Tooltip,
  Link,
  Typography,
  Skeleton,
  useMediaQuery,
} from "@mui/material";
import React, { useCallback, useEffect } from "react";
import { IPolicy } from "../../../../models/user/dashboard/Dashboard";
import PolicyCard from "../PolicyCard/PolicyCard";
import { getPolicies } from "../Policies";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { RootState } from "../../../../store/store";
import { GetPoliciesData } from "../../DashboardAction";
import { getBufferData, getCookie } from "../../../../utils/Utility";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import PolicyDetailsStyles from "../../../PolicyDetails/PolicyDetailsStyles";
import { useTranslation } from "react-i18next";
import { setDownloadIdCardContent } from "../../DashboardSlice";
import { resetCommonSlice } from "../../../../store/common/CommonSlice";

const PoliciesList: React.FC = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width:767px)");

  const { isSuccess, calledReducerType, isError, isLoading } = useAppSelector(
    (store: RootState) => store.common
  );
  const { downloadIdCardContent } = useAppSelector(
    (state: RootState) => state.dashboard
  );

  const { t } = useTranslation();

  const { userDetails } = useAppSelector((state: RootState) => state.userAuth);

  const carrier = getCookie("carrier");
  const system = getCookie("system");

  const handleNavigate = useCallback(() => {
    navigate("/customer/dashboard");
  }, [navigate]);

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  useEffect(() => {
    if (
      isSuccess &&
      calledReducerType === "GetDownloadIdCard" &&
      downloadIdCardContent
    ) {
      const bufferArray = getBufferData(downloadIdCardContent);
      const url = URL.createObjectURL(
        new Blob([bufferArray], { type: "application/pdf" })
      );
      const downloadLink = document.createElement("a");
      downloadLink.download = "Insured ID card.pdf";
      downloadLink.href = url;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      dispatch(setDownloadIdCardContent(null));
    }
  }, [calledReducerType, isSuccess, downloadIdCardContent, dispatch]);

  useEffect(() => {
    if (isError && calledReducerType === "GetDownloadIdCard") {
      alert(`Error in downloading document`);
      dispatch(resetCommonSlice());
    }
  }, [calledReducerType, isError, dispatch]);
  useEffect(() => {
    if (userDetails && userDetails.customerId && carrier && system) {
      dispatch(
        GetPoliciesData({
          customerId: userDetails?.customerId,
          carrier,
          system,
        })
      );
    }
  }, [userDetails, dispatch, carrier, system]);

  const { policiesData } = useAppSelector(
    (store: RootState) => store.dashboard
  );

  return (
    <Box sx={PolicyDetailsStyles.policyDetailsContainer}>
      <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
        <Link onClick={handleNavigate} sx={PolicyDetailsStyles.link}>
          <Tooltip title="Go to Dashboard">
            <KeyboardArrowLeftIcon />
          </Tooltip>
        </Link>
        <Typography>{t("Back to Dashboard")}</Typography>
      </Box>

      {isLoading && calledReducerType === "dashboard/GetPoliciesData" ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: isMobile ? "column" : "row",
            flexWrap: "wrap",
            paddingY: "0.5rem",
            gap: "0.8rem ",
          }}
        >
          {Array.from(Array(4)).map((_, index) => (
            <Skeleton
              key={index}
              variant="rounded"
              height="250px"
              animation="wave"
              sx={{
                width: isMobile ? "100%" : "auto",
                minWidth: isMobile ? "100%" : "466px",
                flex: 1,
              }}
            />
          ))}
        </Box>
      ) : (
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
            gap: "10px",
            "@media(max-width: 992px)": {
              gridTemplateColumns: "1fr",
            },
          }}
        >
          {getPolicies(policiesData).map((policy: IPolicy) => (
            <PolicyCard policy={policy} key={policy.policyId} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PoliciesList;
